query ApprovalSetupMap($entityId: UUID!, $orderBy: [ApprovalMapTypesOrderBy!]) {
  approvalSetupMap(approvalId: $entityId, orderBy: $orderBy) {
    nodes {
      id
      approvalType
      isApproval
      isApproved
      isTree
      isBranch
      name
      topic
      subTopic
      level
      parentId
    }
  }
}
